module.exports = __webpack_public_path__ + "img/45000.25c99476.jpg";